import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import { FileUpload } from "primereact/fileupload";
import moment from "moment";
import { uploadJPEG, getCocoaPercentChanges, fileUpload, dataUrItoBlob } from "../../../utils/utils";
import { api_key, C3_api_key } from "../../../utils/common";
import { isEarlyMarketEmpty } from "../utils/utils";
import service from "../../../utils/service";
import cloneDeep from "lodash.clonedeep";
import { isEmpty, range } from "lodash";
import ThreeDotsLoader from "../../common/ThreeDotsLoader";
import useSaveEarlyMarkets from "../hooks/useSaveEarlyMarkets";
import { Messages } from "primereact/messages";
import {
  REGIONS,
  GENERATE_IMAGE_BUSINESS_UNITS,
  USD_CURRENCY_SYMBOL,
  chart_symbols,
  COLOR_CODES,
} from "../constants/constants";
import { BUSINESS_UNIT } from "../../../utils/PreviousSession.constants";
import { TRANSLATIONS } from "../../../constants/translations.constants";
import { EditContentDialog } from "./EditContentDialog";

function EarlyMarkets(props) {
  const [loading, setLoading] = useState(props.loading);
  const [commodityInfo, setCommodityInfo] = useState([]);
  const [tempCommodityInfo, setTempCommodityInfo] = useState([]);
  const [editContent, setEditContent] = useState(false);
  const [isSectionInValid, setIsSectionInValid] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [showImage1, setShowImage1] = useState(false);
  const [chartConfig, setChartConfig] = useState([]);
  const [chartData, setChartdata] = useState([]);
  const [chartData1, setChartdata1] = useState([]);
  const [chartLabels, setchartlabels] = useState([]);
  const [chartLabels1, setchartlabels1] = useState([]);
  const [uploadedImage, setUploadedImage] = useState(false);
  const [uploadedImage1, setUploadedImage1] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [commoditiesPerRow, setCommoditiesPerRow] = useState(6);
  const [uploadPercent, setUploadPercent] = useState(0);
  const mutation = useSaveEarlyMarkets();
  const chartRef = useRef();
  const chartRef1 = useRef();
  const msgRef = useRef();
  const BUSINESS_UNITS = Object.keys(GENERATE_IMAGE_BUSINESS_UNITS);

  const { section, businessUnit, region, closeDate, previousCloseDate } = props;
  const { syndicationCommodities } = section;

  // Get the translations for the region
  const unchangedText = TRANSLATIONS[region]["Unchanged"];
  const lowerText = TRANSLATIONS[region]["lower"];
  const higherText = TRANSLATIONS[region]["higher"];
  const lastCloseDateText = TRANSLATIONS[region]["Last Close Date"];
  const previousCloseDateText = TRANSLATIONS[region]["Previous Close Date"];
  const sourceText = TRANSLATIONS[region]["Source"];
  const weeklyPercentageChangeText = TRANSLATIONS[region]["Weekly % Changes"];

  const multiAxisData = {
    labels: chartLabels,
    datasets: chartData.map((item) => {
      return {
        ...item[0],
        data: item[1],
        fill: false,
        pointRadius: "0",
        borderWidth: 2.5,
      };
    }),
  };

  const multiAxisData1 = {
    labels: chartLabels1,
    datasets: chartData1.map((item) => {
      return {
        ...item[0],
        data: item[1],
        fill: false,
        pointRadius: "0",
        borderWidth: 2.5,
      };
    }),
  };

  const initiAxisOptions = {
    animation: {
      duration: 1,
      easing: "easeInQuad",
    },

    tooltips: {
      enabled: false,
    },
    events: [],

    stacked: false,
    scales: {
      x: {
        ticks: {
          color: "#495057",
          autoSkip: true,
          maxTicksLimit: 13,
          maxRotation: 0,
          minRotation: 0,
        },
        grid: {
          drawOnChartArea: false,
          drawTicks: true,
          tickLength: 7,
          display: true,
          lineWidth: 2,
        },
      },
    },
    plugins: {
      title: {
        text: `${sourceText}: Barchart.com`,
        display: true,
        position: "bottom",
        padding: 0,
      },
      legend: {
        position: "bottom",
        labels: {
          filter: (item, chart) => {
            item.lineWidth = 5;
            if (chart.datasets.length > 0 && item.text.includes(USD_CURRENCY_SYMBOL)) {
            }
            return item;
          },
          usePointStyle: true,
        },
      },
    },
    layout: {
      padding: 20,
    },
    devicePixelRatio: window.devicePixelRatio !== 2 ? window.devicePixelRatio * 2 : window.devicePixelRatio,
  };

  const [multiAxisOptions, setMultiAxisOptions] = useState(initiAxisOptions);
  const [multiAxisOptions1, setMultiAxisOptions1] = useState(initiAxisOptions);

  var minUsdVal = Number.MAX_VALUE;
  var minEurVal = Number.MAX_VALUE;
  var maxUsdVal = 0;
  var maxEurVal = 0;

  const handleCommodityInfo = () => {
    if (syndicationCommodities) {
      const commodityArr = syndicationCommodities.map((syndicationCommodity) => {
        const { commodity, commoditySymbol, percentageChange } = syndicationCommodity;
        let percentageChangeValue = "";
        let suffix = "";
        if (percentageChange?.includes("%")) {
          percentageChangeValue = percentageChange.split("%")[0];
          suffix = "%";
        } else if (percentageChange === unchangedText) {
          percentageChangeValue = "0";
          suffix = "";
        } else {
          percentageChangeValue = percentageChange.split(" ")[0];
          suffix = "";
        }
        const { color, img } = handleStyleImageAndSuffix(percentageChangeValue);
        percentageChangeValue = `${percentageChangeValue}${suffix}`;
        return {
          commodity,
          commoditySymbol,
          percentageChange,
          styleObject: { color },
          percentageChangeValue,
          isValidPercentValue: true,
          img: img,
        };
      });
      setCommodityInfo(commodityArr);
    }
  };

  const handleCocoaCommodityInfo = useCallback(async () => {
    if (syndicationCommodities?.length > 0) {
      const { percentageChangeValue } = syndicationCommodities[0];
      // This is to avoid the API call if the percentageChangeValue is already present
      if (percentageChangeValue) return;
      const commodities = JSON.parse(JSON.stringify(syndicationCommodities));
      const cocoaBarchartSymbols = [];
      const cocoaBarchartObjects = [];
      commodities.forEach((commodity) => {
        if (commodity.commoditySymbol !== null) {
          if (region === "NA") {
            cocoaBarchartSymbols.push(commodity.commoditySymbol + "*2");
          } else {
            cocoaBarchartSymbols.push(commodity.commoditySymbol + "*1");
          }
          cocoaBarchartObjects.push(commodity);
        }
      });
      if (cocoaBarchartSymbols?.length > 0) {
        const cocoaResponse = await getCocoaPercentChanges(
          cocoaBarchartSymbols,
          props.closeDate,
          props.previousCloseDate
        );
        for (let i = 0; i < cocoaResponse.length; i++) {
          const { percentChange } = cocoaResponse[i];
          const commodity = cocoaBarchartObjects[i];
          commodity.percentageChange = percentChange;
        }
      }
      const updatedCommodities = commodities.map((commodity) => {
        const { percentageChange } = commodity;
        const { color, img, text } = handleStyleImageAndSuffix(percentageChange);
        commodity.percentageChangeValue = percentageChange;
        if (percentageChange !== "0" && percentageChange !== "0.0") {
          commodity.percentageChange = `${percentageChange}% ${text}`;
        } else {
          commodity.percentageChange = `${text}`;
        }
        return {
          ...commodity,
          styleObject: { color },
          img: img,
        };
      });

      setCommodityInfo(updatedCommodities);
    }
  }, [syndicationCommodities, previousCloseDate, closeDate]);

  React.useEffect(() => {
    if (businessUnit === BUSINESS_UNIT.COCOA) {
      handleCocoaCommodityInfo();
    } else {
      handleCommodityInfo();
    }
  }, [syndicationCommodities, businessUnit]);

  function handleEdit() {
    setTempCommodityInfo(JSON.parse(JSON.stringify(commodityInfo)));
    setEditContent(true);
    props.setEditing("earlyMarket", true, false);
  }

  function handleCancel() {
    setEditContent(false);
  }

  function handleEditContentSave() {
    setCommodityInfo(tempCommodityInfo);
    const updatedSection = { ...section, syndicationCommodities: tempCommodityInfo };
    props.getSectionData(updatedSection);
    setEditContent(false);
  }

  function handleStyleImageAndSuffix(value) {
    let color, img, text;
    if (!isNaN(value)) {
      if (value > 0) {
        color = COLOR_CODES["638C1C"];
        img = "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/upArrow.png";
        text = higherText;
      } else if (value < 0) {
        color = COLOR_CODES.A22B2F;
        img = "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/downArrow.png";
        text = lowerText;
      } else {
        color = COLOR_CODES["638C1C"];
        text = unchangedText;
      }
    }
    return { color, img, text };
  }

  function handleEditContentChange(event, index) {
    let { value } = event.target;
    const updatedCommodityInfo = [...tempCommodityInfo];
    const commodity = updatedCommodityInfo[index];

    // Regular expression to check for valid input (including trailing decimal point)
    const regex = /^-?\d*\.?\d*%?$/;

    // Validate input: check for empty, single "-", or valid regex match
    if (value === "" || value === "-" || regex.test(value)) {
      // Prevent multiple dots or percentages
      if ((value.match(/\./g) || []).length <= 1 && (value.match(/%/g) || []).length <= 1) {
        const wholeNum = value.split("%")[0];
        commodity.percentageChangeValue = value;

        // Handle the display of percentage change
        if (!wholeNum && wholeNum !== "-") {
          commodity.percentageChange = value;
        } else {
          const { color, img, text } = handleStyleImageAndSuffix(wholeNum);
          commodity.styleObject = { color };
          commodity.img = img;
          if (Math.abs(Number(wholeNum)) > 0.000001 && !value.endsWith(".")) {
            commodity.percentageChange = `${value} ${text}`;
          } else if (value.endsWith(".")) {
            commodity.percentageChange = value;
          } else {
            commodity.percentageChange = `${text}`;
          }
        }
        setTempCommodityInfo(updatedCommodityInfo);
      }
    }
  }

  function handleSectionSave() {
    if (isEarlyMarketEmpty(section)) {
      setIsSectionInValid(true);
    } else {
      mutation.mutate(
        {
          ...section,
          syndicationCommodities: commodityInfo,
          reportDate: props.reportDate,
          regionId: props.regionId,
          productLineId: props.productLineId,
        },
        {
          onSuccess: (data) => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: false,
                  severity: "success",
                  summary: "Success",
                  detail: "Early Markets saved successfully",
                  closable: false,
                  life: 2000,
                },
              ]);
            }
            props.setEditing("earlyMarket", false, false);
            props.updateSectionId("earlyMarket", data.data);
            mutation.reset();
          },
          onError: () => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: true,
                  severity: "error",
                  summary: "Error",
                  detail: "Error saving Early Markets",
                  closable: true,
                },
              ]);
            }
            props.setEditing("earlyMarket", true, false);
            mutation.reset();
          },
        }
      );
    }
  }

  const counterArr = [0, 0];
  const chartRefs = [chartRef, chartRef1];
  const uploadedImages = [uploadedImage, uploadedImage1];
  const setUploadedImages = [setUploadedImage, setUploadedImage1];

  const uploadImage = (index) => {
    counterArr[index]++;
    const node = chartRefs[index].current;
    if (!node) return false;
    const currentCanvas = node.getCanvas();
    const context = currentCanvas.getContext("2d");
    context.save();
    context.globalCompositeOperation = "destination-over";
    context.fillStyle = "white";
    context.fillRect(0, 0, currentCanvas.width, currentCanvas.height);
    context.restore();
    if (!uploadedImages[index] && counterArr[index] === 1) {
      currentCanvas.toBlob(
        (blob) => {
          const base64DataURI = node.getBase64Image();
          const blobFromDataURI = dataUrItoBlob(base64DataURI);
          uploadJPEG(
            blobFromDataURI,
            section,
            `${props.businessUnit}${props.region}${moment(props.selectedDate).format("YYYYMMDD")}pricedata${index}.jpeg`
          ).then((imagePath) => {
            props.updateImagePath(section, imagePath, index);
            setUploadedImages[index](true);
          });
        },
        "image/jpeg",
        0.95
      );
    }
  };

  function linear_interpolate(x, y, n) {
    const diff = (y - x) / (n + 1);
    return Array(n)
      .fill(0)
      .map((item, index) => Math.floor((x + (index + 1) * diff) * 100) / 100);
  }

  async function recurse_request(i, n, chart_data, chartConfig, ind) {
    console.log("🚀 ~ recurse_request ~ ind:", ind);
    console.log("🚀 ~ recurse_request ~ chartConfig:", chartConfig);
    console.log("🚀 ~ recurse_request ~ chart_data:", chart_data);
    const symbols = chartConfig.symbols;
    if (i === n) {
      var axisOptions = cloneDeep(initiAxisOptions);
      let scales = {};
      chartConfig.axis.forEach((axis) => {
        scales[axis.id] = axis;
      });
      axisOptions.scales = {
        ...axisOptions.scales,
        ...scales,
      };
      if (parseInt(ind) === 0) {
        axisOptions.animation.onComplete = () => uploadImage(0);
        setMultiAxisOptions(axisOptions);
        setChartdata(chart_data);
        setShowImage(true);
      } else {
        axisOptions.animation.onComplete = () => uploadImage(1);
        const source = props.businessUnit !== BUSINESS_UNIT.COCOA ? "Barchart.com" : "CRA";
        setMultiAxisOptions1({
          ...axisOptions,
          plugins: {
            ...axisOptions.plugins,
            title: {
              ...axisOptions.plugins.title,
              text: `${sourceText}: ${source}`,
            },
          },
        });
        setChartdata1(chart_data);
        setShowImage1(true);
      }
      setDisableButton(false);
    } else {
      var data_json = {};
      var start_date = moment(props.selectedDate).subtract(chartConfig.unitValue, chartConfig.unit).format("YYYYMMDD");
      var end_date = moment(props.selectedDate).format("YYYYMMMDD");
      if (symbols[i].source === "cra") {
        data_json["start_date"] = moment(start_date).format("YYYY-MM-DD");
        data_json["end_date"] = moment(end_date).format("YYYY-MM-DD");
        data_json["region_id"] = symbols[i].regionId;
        data_json["symbol"] = symbols[i].name;
      } else {
        data_json["startDate"] = start_date;
        data_json["endDate"] = end_date;
        data_json["type"] = "dailyNearest";
        data_json["symbol"] = symbols[i].name;

        if (symbols[i].name.startsWith("C3:")) {
          data_json["apikey"] = C3_api_key;
        } else {
          data_json["apikey"] = api_key;
        }
      }

      service.getPricedata(data_json, symbols[i].source).then((resp) => {
        const source = symbols[i].source;
        var data;
        if (source === "cra") {
          data = resp.data;
        } else {
          data = resp.results;
          if (props.businessUnit === BUSINESS_UNIT.COCOA) {
            const closeDateObj = new Date(props.closeDate);
            data = data.filter((item) => {
              const itemDate = new Date(item.tradingDay);
              return itemDate <= closeDateObj;
            });
          }
        }

        if (i === 0) {
          const start_date = moment(props.selectedDate).subtract(chartConfig.unitValue, chartConfig.unit);
          const diff_date = moment(props.selectedDate).diff(start_date, "days");
          var labels = [start_date];
          for (var k = 1; k < diff_date; k++) {
            labels.push(moment(labels[k - 1]).add(1, "days"));
          }
          labels = labels.map((item) => item.format("DD-MMM") + "  ");
          if (parseInt(ind) === 0) {
            setchartlabels(labels);
          } else {
            setchartlabels1(labels);
          }
        }

        if (symbols[i].currency === USD_CURRENCY_SYMBOL) {
          minUsdVal = Math.min(minUsdVal, Math.min(...data.map((dat) => dat.close)));
          maxUsdVal = Math.max(maxUsdVal, Math.max(...data.map((dat) => dat.close)));
        } else {
          minEurVal = Math.min(minEurVal, Math.min(...data.map((dat) => dat.close)));
          maxEurVal = Math.max(maxEurVal, Math.max(...data.map((dat) => dat.close)));
        }

        var temp_struct = [symbols[i].config];
        var temp_data = [];
        var prev_date = null;
        for (var j = 0; j < data.length; j++) {
          const item = data[j];
          var cur_date = source === "cra" ? moment(item.reportDate) : moment(item.tradingDay);
          var cur_value = source === "cra" ? item.commodityPrice : item.close;
          if (cur_value === null) {
            continue;
          }
          cur_value = Math.floor(cur_value * 100) / 100;
          const date_diff = cur_date.diff(prev_date, "days");
          if (prev_date !== null && date_diff > 1) {
            temp_data = temp_data.concat(linear_interpolate(temp_data[temp_data.length - 1], cur_value, date_diff - 1));
          }
          prev_date = cur_date;
          temp_data.push(cur_value);
        }
        temp_struct.push(temp_data);

        chart_data.push(temp_struct);
        recurse_request(i + 1, n, chart_data, chartConfig, ind);
      });
    }
  }

  const handleClick = () => {
    setDisableButton(true);
    for (var i in chartConfig) {
      if (parseInt(i) === 0 && section.imagePath === "") {
        recurse_request(0, chartConfig[i].symbols.length, [], chartConfig[i], i);
      }
      if (parseInt(i) === 1 && section.imagePath2 === "") {
        recurse_request(0, chartConfig[i].symbols.length, [], chartConfig[i], i);
      }
    }
    props.setEditing("earlyMarket", true, false);
  };

  const uploadProgressHandler = (total, loaded) => {
    const percent = Math.round((100 * loaded) / total);
    setUploadPercent(percent);
  };
  const handleImageUpload = (e) => {
    const files = e.files;
    if (files.length > 0) {
      const file = files[0];
      if (section.imagePath === "") {
        setUploadPercent(1);
        fileUpload(file, section, uploadProgressHandler)
          .then((imagePath) => {
            props.updateImagePath(section, imagePath, 0);
          })
          .catch((err) => setUploadPercent(0));
        if (files.length > 1) {
          const file = files[1];
          setUploadPercent(1);
          fileUpload(file, section, uploadProgressHandler)
            .then((imagePath) => {
              props.updateImagePath(section, imagePath, 1);
            })
            .catch((err) => setUploadPercent(0));
        }
      } else {
        setUploadPercent(1);
        fileUpload(file, section, uploadProgressHandler)
          .then((imagePath) => {
            props.updateImagePath(section, imagePath, 1);
          })
          .catch((err) => setUploadPercent(0));
      }
      props.setEditing("earlyMarket", true, false);
    }
  };

  React.useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  React.useEffect(() => {
    const noofCommodities = commodityInfo.length || 1;
    if (noofCommodities <= 6) {
      setCommoditiesPerRow(noofCommodities);
    } else {
      setCommoditiesPerRow(Math.round(noofCommodities / 2));
    }
  }, [commodityInfo]);

  const headerImgSrc =
    props.businessUnit !== BUSINESS_UNIT.COCOA
      ? props.businessUnit === BUSINESS_UNIT.GRAINS
        ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/grains_early_markets_header.png"
        : props.region === REGIONS.SA
          ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/CurrentMarkets.png"
          : "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/EarlymarketsHeader.png"
      : "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/cocoa_early_markets.png";

  const second_photo =
    chartConfig.length > 1 &&
    !isEmpty(section) &&
    section.imagePath2 !== null &&
    (section.imagePath2 !== "" ? (
      <React.Fragment>
        <img
          width={800}
          height={300}
          alt='Early market Img2'
          style={{
            backgroundColor: "white",
            border: "1px solid #DDD",
            padding: "5px",
          }}
          src={decodeURIComponent(encodeURIComponent(section.imagePath2))}
        />
      </React.Fragment>
    ) : showImage1 ? (
      <div style={{ width: "800px", height: "300px", position: "absolute", left: -999999 }}>
        <Chart width='800' height='300' ref={chartRef1} type='line' data={multiAxisData1} options={multiAxisOptions1} />
      </div>
    ) : (
      <div>
        <FileUpload
          className='fileUpload mx-0 p-button-sm floatLeft'
          customUpload
          uploadHandler={handleImageUpload}
          chooseLabel='Choose File'
          mode='basic'
          auto
          multiple
        />
        <Button
          className='p-button p-button-sm diag-save-button'
          label='Generate Image'
          onClick={() => handleClick()}
        />
        <Button
          pt={{ label: { className: "mx-0" } }}
          className='p-button p-button-sm diag-save-button savesectionbtn'
          label='Save Section Content & Image'
          onClick={() => handleSectionSave()}
        />
      </div>
    ));

  React.useEffect(() => {
    if (props.businessUnit !== undefined && props.businessUnit !== "" && props.region !== undefined) {
      let chartSymbolBusiness = chart_symbols[props.businessUnit];
      let chartRegions = chartSymbolBusiness && chartSymbolBusiness[props.region];
      if (chartRegions) setChartConfig(chartRegions);
    }
    setShowImage(false);
    setShowImage1(false);
    setUploadedImage(false);
    setUploadedImage1(false);
  }, [props.region, props.businessUnit]);

  const showGenerateImage =
    BUSINESS_UNITS.includes(props.businessUnit) &&
    GENERATE_IMAGE_BUSINESS_UNITS[props.businessUnit].includes(props.region);
  return (
    <div className='relative syndication__section__wrapper'>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td>
              <img
                src={decodeURIComponent(encodeURIComponent(props?.section?.headerImagePath || headerImgSrc))}
                alt='Early market header'
                width='800'
                height='50'
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {(loading || mutation.isLoading) && (
        <div className='wtg__loader absolute'>
          <ThreeDotsLoader className='absolute' />
        </div>
      )}
      <table width='800' align='center' className='msg__container'>
        <Messages
          className='msg__content'
          ref={msgRef}
          onRemove={() => {
            console.log("REMOVED");
          }}
        />
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
          marginBottom: "10px",
        }}
      >
        <tbody>
          <th
            width='8%'
            rowSpan={12}
            style={{
              fontSize: "12px",
              color: props.businessUnit !== BUSINESS_UNIT.COCOA ? "#638C1C" : "#be621c",
              fontStyle: "italic",
              verticalAlign: "middle",
            }}
          >
            {(props.businessUnit === BUSINESS_UNIT.COCOA ||
              (props.businessUnit === BUSINESS_UNIT.EDIBLE_OILS && props.region === REGIONS.EMEA) ||
              props.businessUnit === BUSINESS_UNIT.GRAINS ||
              props.businessUnit === BUSINESS_UNIT.ANIMAL_FEED) && <span>{weeklyPercentageChangeText}</span>}
            <br />
            {props.publish === false && props.diff_date >= 0 ? (
              // <tr>
              //   <td>
              <span
                className='editContent'
                style={{ fontSize: "13px", color: "grey", fontWeight: "400" }}
                onClick={() => {
                  handleEdit();
                }}
              >
                Edit Content
              </span>
            ) : (
              //   </td>
              // </tr>
              <></>
            )}
          </th>
          {commodityInfo.length > 0 &&
            range(commodityInfo.length / commoditiesPerRow).map((i) => {
              return (
                <React.Fragment key={`key-${i}`}>
                  <tr
                    valign='top'
                    align='center'
                    style={{
                      color: props.businessUnit !== BUSINESS_UNIT.COCOA ? "#638C1C" : "#be621c",
                      fontWeight: "bold",
                      verticalAlign: "top",
                    }}
                  >
                    {range(Math.min(commoditiesPerRow, commodityInfo.length - commoditiesPerRow * i)).map((j) => {
                      const obj = commodityInfo[commoditiesPerRow * i + j];
                      return (
                        <td key={j}>
                          {obj.commodity}
                          {props.businessUnit === BUSINESS_UNIT.COCOA &&
                            (obj.commoditySymbol === null ? <sup>1</sup> : <sup>2</sup>)}
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    {range(Math.min(commoditiesPerRow, commodityInfo.length - commoditiesPerRow * i)).map((j) => {
                      const obj = commodityInfo[commoditiesPerRow * i + j];
                      return (
                        <td align='center' style={{ paddingBottom: "1rem" }} key={j}>
                          <span>
                            {obj.img && <img alt='price img' style={{ verticalAlign: "middle" }} src={obj.img} />}
                            <span
                              style={{ margin: "2px", verticalAlign: "middle", fontSize: "16px", ...obj.styleObject }}
                            >
                              {obj.percentageChange}
                            </span>
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                </React.Fragment>
              );
            })}
        </tbody>
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          color: "#cccccc",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          {props.businessUnit === BUSINESS_UNIT.COCOA ? (
            <>
              {/* <tr></tr>
              <tr></tr> */}
              <tr align='right'>
                <td width='320' style={{ fontSize: "13px", color: "grey", fontWeight: "400" }}>
                  <span style={{ color: "#be621c", fontSize: "14px", fontWeight: "bold" }}>{sourceText}: </span>
                  <span>1 - CRA, </span>
                  <span>2 - Barchart</span>
                </td>
              </tr>
              <tr align='right' style={{ color: "#be621c", fontSize: "12px", fontWeight: "bold" }}>
                <td width='320' style={{ fontSize: "13px", color: "grey", fontWeight: "400" }}>
                  <span style={{ color: "#be621c", fontSize: "14px", fontWeight: "bold" }}>{lastCloseDateText}: </span>
                  <span>{region === REGIONS.NA ? props.closeDate : moment(props.closeDate).format("DD/MM/YYYY")}</span>
                </td>
              </tr>
            </>
          ) : (
            props.businessUnit === BUSINESS_UNIT.GRAINS && (
              <tr align='right' style={{ color: "#638C1C", fontSize: "12px", fontWeight: "bold" }}>
                <td width='100'>
                  <sup>*</sup>Calculated by comparing the settlement price of today's date with the settlement price of
                  one week ago
                </td>
              </tr>
            )
          )}
          {props.region === "LA" ? (
            ["FOB Paranagua", "FOB Argentina", "FOB Malaysia", "FOB Malaysia"].map((value) => {
              return (
                <td align='center' style={{ color: "#638C1C" }}>
                  {value}
                </td>
              );
            })
          ) : (
            <></>
          )}
        </tbody>
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          color: "#cccccc",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td valign='top'>
              {!showImage && section.imagePath === "" && !showImage1 ? (
                props.diff_date >= 0 && (
                  <div>
                    <FileUpload
                      className='fileUpload mx-0 p-button-sm floatLeft generateImage'
                      customUpload
                      uploadHandler={handleImageUpload}
                      chooseLabel={chartConfig.length > 1 ? "Choose Files" : "Choose File"}
                      mode='basic'
                      auto
                      multiple
                      disabled={disableButton || ![0, 100].includes(uploadPercent)}
                      pt={{
                        chooseIcon: "hidden",
                      }}
                    />
                    {/* {props.region !== 'SA' && <Button className="p-button p-button-sm diag-save-button" label="Generate Image" onClick={(e) => handleImageUpload(e)}/>} */}
                    {showGenerateImage && (
                      <Button
                        className='p-button p-button-sm diag-save-button generateImage'
                        disabled={disableButton || ![0, 100].includes(uploadPercent) ? true : false}
                        icon={disableButton ? "pi pi-spin pi-spinner" : null}
                        iconPos='right'
                        label='Generate Image'
                        onClick={() => handleClick()}
                      />
                    )}
                    <Button
                      pt={{ label: { className: "mx-0" } }}
                      disabled={disableButton || ![0, 100].includes(uploadPercent)}
                      className='p-button p-button-sm diag-save-button savesectionbtn'
                      label='Save Section Content & Image'
                      onClick={() => handleSectionSave()}
                    />
                  </div>
                )
              ) : section.imagePath !== "" ? (
                <>
                  <img
                    width={800}
                    height={300}
                    alt='Early market Img1'
                    style={{
                      backgroundColor: "white",
                      border: "1px solid #DDD",
                      padding: "5px",
                    }}
                    src={decodeURIComponent(encodeURIComponent(section.imagePath))}
                    onLoad={() => setIsImageLoading(false)}
                  />
                  {second_photo}
                  {isImageLoading && (
                    <>
                      <FileUpload
                        className='fileUpload mx-0 p-button-sm floatLeft generateImage'
                        customUpload
                        chooseLabel={chartConfig.length > 1 ? "Choose Files" : "Choose File"}
                        mode='basic'
                        auto
                        multiple
                        disabled={true}
                        pt={{
                          chooseIcon: "hidden",
                        }}
                      />
                      {/* {props.region !== 'SA' && <Button className="p-button p-button-sm diag-save-button" label="Generate Image" onClick={(e) => handleImageUpload(e)}/>} */}
                      {showGenerateImage && (
                        <Button
                          className='p-button p-button-sm diag-save-button generateImage'
                          disabled={true}
                          icon={"pi pi-spin pi-spinner"}
                          iconPos='right'
                          label='Generate Image'
                        />
                      )}
                      <Button
                        pt={{ label: { className: "mx-0" } }}
                        disabled={true}
                        className='p-button p-button-sm diag-save-button savesectionbtn'
                        label='Save Section Content & Image'
                      />
                    </>
                  )}
                </>
              ) : (
                <>
                  <div style={{ width: "800px", height: "300px", position: "absolute", left: -999999 }}>
                    <Chart
                      width='800'
                      height='300'
                      ref={chartRef}
                      type='line'
                      data={multiAxisData}
                      options={multiAxisOptions}
                    />
                    {second_photo}
                  </div>
                  <FileUpload
                    className='fileUpload mx-0 p-button-sm floatLeft generateImage'
                    customUpload
                    chooseLabel={chartConfig.length > 1 ? "Choose Files" : "Choose File"}
                    mode='basic'
                    auto
                    multiple
                    disabled={true}
                    pt={{
                      chooseIcon: "hidden",
                    }}
                  />
                  {/* {props.region !== 'SA' && <Button className="p-button p-button-sm diag-save-button" label="Generate Image" onClick={(e) => handleImageUpload(e)}/>} */}
                  {showGenerateImage && (
                    <Button
                      className='p-button p-button-sm diag-save-button generateImage'
                      disabled={true}
                      icon={"pi pi-spin pi-spinner"}
                      iconPos='right'
                      label='Generate Image'
                    />
                  )}
                  <Button
                    pt={{ label: { className: "mx-0" } }}
                    disabled={true}
                    className='p-button p-button-sm diag-save-button savesectionbtn'
                    label='Save Section Content & Image'
                  />
                </>
              )}
              {section.imagePath !== "" && (
                <div>
                  {props.publish === false && props.diff_date >= 0 && !isImageLoading && (
                    <>
                      <button
                        className='RemoveImage p-button p-button-sm diag-save-button floatRight'
                        style={{
                          borderRadius: "35px",
                          textAlign: "center",
                          padding: "10px",
                          color: "#FFFFFF",
                          boxSizing: "border-box",
                          backgroundColor: "#199B8B",
                        }}
                        onClick={() => {
                          setShowImage(false);
                          setShowImage1(false);
                          setUploadedImage(false);
                          setUploadedImage1(false);
                          setUploadPercent(0);
                          setDisableButton(false);
                          props.updateImagePath(section, "", 0);
                          props.updateImagePath(section, "", 1);
                          props.setEditing("earlyMarket", true, false);
                        }}
                      >
                        Remove image
                      </button>
                      <Button
                        pt={{ label: { className: "mx-0" } }}
                        className='p-button p-button-sm diag-save-button savesectionbtn'
                        label='Save Section Content & Image'
                        onClick={() => handleSectionSave()}
                      />
                    </>
                  )}
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      <EditContentDialog
        editContent={editContent}
        handleCancel={handleCancel}
        commodityInfo={tempCommodityInfo}
        handleEditContentChange={handleEditContentChange}
        handleEditContentSave={handleEditContentSave}
        region={region}
      />

      <Dialog
        header='Early Markets Validation'
        className='section__validation__dialog'
        baseZIndex={10001}
        visible={isSectionInValid}
        modal
        style={{ width: "350px" }}
        footer={
          <Button
            label='Okay'
            icon='pi pi-check'
            onClick={() => setIsSectionInValid(false)}
            className='p-button-text'
          />
        }
        onHide={() => setIsSectionInValid(false)}
      >
        <div className='flex flex-column' style={{ color: "#FFF" }}>
          <div className='flex align-items-center'>
            <i className='pi pi-exclamation-triangle mr-3' style={{ fontSize: "2rem" }} />
            <span>Please fill the section content</span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default EarlyMarkets;
